import { colorTheme } from "react-native-web-uikit";
const colors = colorTheme.light;

export const getTransparentColor = (color: string) => {
  return `${color}44`;
};

export default colors;
